import React from 'react'
import Marquee from "react-fast-marquee";
import Loading from '../loader/loader';
import MiniNews from '../home/miniNews';

const NewsSlider = ({ news, isLoading }) => {

    return (
        <div className='bg-blue py-2 dark:bg-dark-box w-full
                        flex justify-center dark:text-dark-text'>
            <div className='w-[98vw]'>
                <Marquee pauseOnHover gradient={false} speed={25}>
                    {isLoading ? (
                        <Loading />
                    ) : (
                        <div className="flex">
                            {news.length > 0 &&
                                news.map((news, key) => {
                                  return  <div key={key}><MiniNews i={key} n={news} /></div>
                                })}
                        </div>
                    )}
                </Marquee></div>
        </div>
    )
}

export default NewsSlider